<template>
    <div class="wrap">
      <div class="index-wrap">
        <p class="bg bg1"></p>
        <div class="swiper adSwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img
                class="image-game"
                src="../assets/images/landing2/slide_01.jpg"
              />
            </div>
            <div class="swiper-slide">
              <img
                class="image-game"
                src="../assets/images/landing2/slide_02.jpg"
              />
            </div>
          </div>
        </div>
        <p class="bg bg2">
        </p>
        <a
          href="javascript:;"
          @click="
            statistics()
          "
          class="btn"
        ></a>
      </div>
    </div>
  </template>
  
<script src="../../public/swiper-bundle.min.js"></script>
  
  <!-- Meta Pixel Code -->
<script>
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
</script>
<noscript><img height="1" width="1" style="display:none"
src="https://www.facebook.com/tr?id=6315050328532263&ev=PageView&noscript=1"
/></noscript>
<!-- End Meta Pixel Code -->
  
    <script>
    export default {
      components: {},
      name: "landing9",
      data() {
        return {
          adSwiper: null,
        };
      },
      created() {
        fbq('init', '6315050328532263');
        fbq('track', 'PageView');
      },
      mounted() {
        this.adSwiper = new Swiper(".adSwiper", {
          autoplay: {
            delay: 2000, //3秒切换一次
            pauseOnMouseEnter: true, //悬停停止切换
          },
          loop: true,
          allowTouchMove: true,
        });
      },
      //methods中定义事件
      methods: {
        // 打点统计
        statistics() {
          fbq('track', 'Lead');
          // 新开链接跳转
          window.open('https://apps.apple.com/jp/app/%E6%9C%80%E5%BC%B7%E4%B8%89%E5%9B%BD-%E9%BB%84%E9%87%91%E5%9F%8E%E3%81%AE%E6%B1%BA%E6%88%A6/id6445888623?ppid=2d8b7f31-12f4-4ba0-abb5-648a2516f9db');
        },
      },
    };
  </script>
    
    <style lang="less" scoped>
    .wrap {
      background-color: #000;
    }
    .bg {
      width: 100%;
      overflow: hidden;
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
    .bg1 {
      height: 652rem;
      background-image: url(../assets/images/landing2/bg_01.jpg);
    }
    .bg2 {
      height: 1120rem;
      background-image: url(../assets/images/landing2/bg_02.jpg);
    }
    .adSwiper{
      width: 750rem;
      height: 587rem;
    }
    .swiper-slide img{
      width: 100%;
    }
    .btn {
      position: fixed;
      left: 50%;
      bottom: 15rem;
      z-index: 10;
      width: 720rem;
      height: 130rem;
      margin-left: -360rem;
      background-image: url(../assets/images/landing2/btn.png);
      background-size: 100% 100%;
    }
    @media screen and (min-width: 750px) {
      .bg1 {
        height: 652px;
      }
      .bg2 {
        height: 1120px;
      }
      .adSwiper{
        width: 750px;
        height: 587px;
      }
      .index-wrap {
        width: 100%;
        min-width: 750px;
        max-width: 750px;
        margin: 0 auto;
      }
      .btn{
        width: 720px;
        height: 130px;
        bottom: 15px;
        margin-left: -360px;
      }
    }
  </style>
      